<script setup lang="ts">
import { useSlots } from "vue";

const slots = useSlots();

const props = defineProps<{
	colorString: string;
}>();
</script>

<template>
	<v-sheet class="v-sheet--offset mx-auto d-flex" :color="props.colorString">
		<div class="d-flex pa-4 ga-2 w-100">
			<div v-if="slots.prepend" class="d-flex align-center prepend">
				<div>
					<slot name="prepend" />
				</div>
			</div>
			<div class="w-100">
				<slot name="display" />
			</div>
			<v-divider vertical v-if="slots.actions" />
			<div class="actions" v-if="slots.actions">
				<div class="d-flex h-100 align-center">
					<slot name="actions"></slot>
				</div>
			</div>
		</div>
	</v-sheet>
</template>

<style scoped lang="scss">
.align-center {
	align-items: center;
}

.prepend {
	width: 50px !important;
}

/* Sized by its buttons rather than a fixed column, so the rule text gets the space. */
.actions {
	flex: 0 0 auto;
	align-self: center;
}
</style>
